import React, { useState } from "react";
import Overview from "./Overview";
import Compare from "./Compare";
import styled from "styled-components";
import Breadcrumbs from "../../components/Breadcrumbs";
import { Tabs } from "antd";
import Detail from "./Detail";
import { useDispatch } from "react-redux";
import { getDataMathMatch } from "../../../redux/Future/Mytel/action";
import { apiRevenueMathMatch } from "../../../api/ApiMytel";

export default function MathMatch() {
  const [tabActive, setTabActive] = useState("1");
  const dispatch = useDispatch();

  const handleGetData = (startDate, endDate) => {
    dispatch(getDataMathMatch(apiRevenueMathMatch(startDate, endDate)));
  };

  const items = [
    {
      key: "1",
      label: "Overview",
      children: <Overview tabActive={tabActive} handleGetData={handleGetData}/>,
    },
    {
      key: "2",
      label: "Details",
      children: <Detail tabActive={tabActive} handleGetData={handleGetData}/>,
    },
    {
      key: "3",
      label: "Compare",
      children: <Compare tabActive={tabActive} handleGetData={handleGetData}/>,
    },
  ];

  const onChangeTabs = (key) => {
    setTabActive(key);
  };
  return (
    <Container>
      <Breadcrumbs data={["Mytel", "Math Match"]} />
      <div className="container-dashboard">
        <Tabs defaultActiveKey="1" items={items} onChange={onChangeTabs} />
      </div>
    </Container>
  );
}

const Container = styled.div`
  .ant-tabs-tab {
    font-size: 15px;
    padding: 5px 20px;
  }
`;
